import { useState } from "react";
import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { useSbState, useHoveredSec } from "../../logic/stores/navigationStore.js";
import { SidebarTooltipPortal } from "./SidebarTooltipPortal.jsx";
import { SidebarLogo } from "./SidebarLogo.jsx";
import { SidebarNavigation } from "./SidebarNavigation.jsx";
import { SidebarProfile } from "./SidebarProfile.jsx";

export function Sidebar() {
  const { c, accentHex: A, dark, typography } = useThemeSlice();
  const sbState = useSbState();
  const hoveredSec = useHoveredSec();

  const isOpen = sbState === "open";
  const isCollapsed = sbState === "collapsed";
  const isClosed = sbState === "closed";
  const SW = isClosed ? 0 : isCollapsed ? 54 : 230;

  const [hoveredTip, setHoveredTip] = useState(null);
  const [tipRect, setTipRect] = useState(null);

  return (
    <>
      <aside
        className="nemo-sidebar"
        style={{
          width: SW,
          minWidth: SW,
          flexShrink: 0,
          background: c.sb,
          borderRight: isClosed ? "none" : `1px solid ${c.sbBdr}`,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          position: "relative",
          fontFamily: typography.fontFamily,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            width: "1.5px",
            background: `linear-gradient(180deg, transparent, ${A} 25%, rgba(201,146,42,0.6) 50%, ${A} 75%, transparent)`,
            opacity: 0.5,
            pointerEvents: "none",
            zIndex: 1,
          }}
        />
        {!isClosed && <SidebarLogo isCollapsed={isCollapsed} />}
        <SidebarNavigation SW={SW} isOpen={isOpen} isCollapsed={isCollapsed} setHoveredTip={setHoveredTip} setTipRect={setTipRect} />
        {!isClosed && (
          <SidebarProfile isOpen={isOpen} isCollapsed={isCollapsed} setHoveredTip={setHoveredTip} setTipRect={setTipRect} />
        )}
      </aside>
      <SidebarTooltipPortal hoveredTip={hoveredTip} tipRect={tipRect} hoveredSec={hoveredSec} dark={dark} isCollapsed={isCollapsed} />
    </>
  );
}
